<template>
  <!-- Start Hero Area -->
  <section id="home" class="hero-area">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-5 col-md-12 col-12">
          <div class="hero-content">
            <h1 class="wow fadeInLeft" data-wow-delay=".4s">বিসিএস প্রস্তুতি <br>ঘরে বসেই চাকরির পূর্ণাঙ্গ প্রস্তুতি</h1>
            <p class="wow fadeInLeft" data-wow-delay=".6s">বিসিএস, ব্যাংক, প্রাইমারি, শিক্ষক নিবন্ধন (NTRCA), সহাকারী জজ সহ সকল  চাকরির প্রস্তুতি হবে এক অ্যাপেই।</p>
            <div class="buttons wow fadeInLeft" data-wow-delay=".8s">
              <a
                  class="play-badge"
                  href="https://play.google.com/store/apps/details?id=com.bcsprostuti.tanim.bcsprostuti&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank" rel="noopener"
                  aria-label="Google Play থেকে ডাউনলোড করুন"
              >
                <img :src="require('@/assets/images/googlePlay.png')" alt="Get it on Google Play" />
              </a>

              <a class="app-call-btn" href="tel:+8801894442944">
                <span>আমাদের কল করুন</span>
                <span class="call-num">০১৮৯৪৪৪২৯৪৪</span>
              </a>

            </div>
            <div v-if="!fromFooter" class="hero-proof wow fadeInLeft">
              <div class="profile-images">
                <img :src="require('@/assets/heroimages/user3.png')" alt="ব্যবহারকারী" width="48" height="48" style="border-radius: 50%" />
                <img :src="require('@/assets/heroimages/user2.png')" alt="ব্যবহারকারী" width="48" height="48" style="border-radius: 50%;     margin-left: -12px;" />
                <img :src="require('@/assets/heroimages/user1.png')" alt="ব্যবহারকারী" width="48" height="48" style="border-radius: 50%;    margin-left: -12px;" />
              </div>
              <div class="proof-meta">
                <span class="proof-rating">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7L12 2z"/></svg>
                  ৪.৩
                </span>
                <span class="proof-divider"></span>
                <span class="total-users">৯ লাখ+ ডাউনলোড</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7 col-md-12 col-12">
          <div class="hero-image wow fadeInRight" data-wow-delay=".4s">
            <img class="hero-image-one" :src="require('@/assets/src.png')" alt="#">
            <img class="hero-image-two" :src="require('@/assets/src2.png')" alt="#">
          </div>
        </div>
      </div>
    </div>

<!--    <div class="container-fluid">-->
<!--      -->
<!--    </div>-->
  </section>
  <!-- End Hero Area -->
</template>
<script>
import {defineComponent} from "vue";


export default defineComponent({
  props: ['fromFooter'],
  components: {},
})
</script>
<style scoped>
.hero-image-one {
  width: 290px;
  height: 580px;
  border-radius: 24px;
  position: relative;
  bottom: -94px;
  z-index: 999;
  -o-object-fit: cover;
  object-fit: cover;
}
.hero-image-two {
  width: 250px;
  height: 530px;
  border-radius: 24px;
  position: relative;
  bottom: -140px;
  left: -28px;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: bottom;
  object-position: bottom;
}

.hero-area .hero-image {
  overflow: hidden;
  text-align: end;
}

.hero-proof {
  margin-top: 36px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.profile-images {
  display: flex;
  align-items: center;
}
.proof-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}
.proof-rating {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: 'Noto Sans Bengali', 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}
.proof-rating svg { color: #FFC83D; }
.proof-divider {
  width: 5px; height: 5px; border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
}
.total-users {
  font-family: 'Noto Sans Bengali', 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #FAFAFA;
}

.hero-area {
  position: relative;
  background: #191B47;
  height: 580px;
  display: flex;

}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .hero-area {
    padding: 150px 0 60px 0;
  }
}

@media (max-width: 767px) {
  .hero-area {
    padding: 50px 0 50px 0;
  }

  .hero-area .hero-image {
    display: none;
  }
}



@media only screen and (min-width: 768px) and (max-width: 991px) {
  .hero-area .hero-image {
    margin-top: 40px;
  }
}

.hero-area .hero-content {
  border-radius: 0;
  position: relative;
  z-index: 1;
  padding-top: 80px;
  text-align: left;
}

.hero-area .hero-content h1 {
  font-family: Noto Sans;
  font-size: 45px;
  font-weight: 700;
  line-height: 55px;
  color: #fff;
  text-shadow: 0px 3px 8px #00000017;
  text-transform: capitalize;
}

.hero-area .hero-content h1 span {
  display: block;
}

.hero-area .hero-content p {
  margin-top: 30px;
  color: #FAFAFA;
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.5px;
}

.hero-area .hero-content .buttons {
  margin-top: 40px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* Google Play badge */
.play-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  text-decoration: none;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.play-badge img {
  display: block;
  height: 56px;
  width: auto;
  border-radius: 10px;
}
.play-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.4);
}

/* Call button */
.app-call-btn {
  display: inline-flex; flex-direction: column; justify-content: center;
  height: 56px;
  padding: 0 22px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff; text-decoration: none;
  line-height: 1.25;
  transition: border-color 0.25s ease, background 0.25s ease;
}
.app-call-btn:hover {
  border-color: #38B6FF;
  background: rgba(0, 149, 255, 0.12);
  color: #fff;
}
.app-call-btn span:first-child { font-size: 0.82rem; opacity: 0.85; }
.app-call-btn .call-num { font-size: 1rem; font-weight: 700; }

@media (max-width: 767px) {
  .hero-area .hero-content .buttons .video-button {
    margin-top: 20px;
  }
}

.hero-area .hero-content .buttons .video-button .text {
  display: inline-block;
  margin-left: 15px;
  color: #fff;
  font-weight: 500;
}

.hero-area .hero-content .buttons .video-button:hover .video {
  color: #fff;
  background-color: #081828;
}

.hero-area .hero-content .buttons .video-button .video {
  height: 50px;
  width: 50px;
  line-height: 50px;
  text-align: center;
  color: #191B47;
  background-color: #fff;
  border-radius: 50%;
  margin-left: 10px;
  font-size: 16px;
  padding-left: 3px;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  position: relative;
}

.hero-area .hero-content .buttons .video-button .video:before {
  position: absolute;
  content: '';
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  border: 1px solid #fff;
  border-radius: 50%;
  -webkit-animation: pulse-border-2 2s linear infinite;
  animation: pulse-border-2 2s linear infinite;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .hero-area .hero-content h1 {
    font-size: 40px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .hero-area .hero-content {
    text-align: center;
  }
  .hero-area .hero-content h1 {
    font-size: 30px;
    font-weight: 700;
    line-height: 38px;
  }
  .hero-area .hero-content p {
    font-size: 15px;
  }
}

@media (max-width: 767px) {
  .hero-area .hero-content {
    padding: 0 10px;
    text-align: center;
  }
  .hero-area .hero-content h1 {
    font-size: 24px;
    line-height: 32px;
  }
  .hero-area .hero-content p {
    margin-top: 15px;
    font-size: 14px;
    line-height: 22px;
  }
  .hero-area .hero-content .buttons {
    justify-content: center;
  }
  .hero-proof {
    justify-content: center;
  }
}

</style>